/* WORKSWEAR: Barrierefreiheit-Helfer
   Fügt App-Elementen (Cart-/Upsell-Apps) nachträglich barrierefreie Namen hinzu.
   Ändert nichts an der Funktion, setzt nur fehlende aria-label / Labels. */
(function () {
  function setLabel(el, label) {
    if (el && !el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
      el.setAttribute('aria-label', label);
    }
  }

  function fix() {
    // Produkt-Links ohne Text (nur Bild) -> Alt-Text oder Fallback
    document.querySelectorAll('a.ezfy-custom-link').forEach(function (a) {
      if (a.getAttribute('aria-label') || a.textContent.trim()) return;
      var img = a.querySelector('img');
      var alt = img && (img.getAttribute('alt') || '').trim();
      a.setAttribute('aria-label', alt && alt.length ? alt : 'Produkt ansehen');
    });

    // Varianten-Auswahl (Opus)
    document.querySelectorAll('select.opus-custom-select').forEach(function (s) {
      setLabel(s, 'Variante wählen');
    });

    // Mengen-Feld (Cart Drawer)
    document.querySelectorAll('input.cd-number-input-field').forEach(function (i) {
      setLabel(i, 'Menge');
    });

    // Buttons ohne sichtbaren Text
    document.querySelectorAll('button.cd-buy-button').forEach(function (b) {
      if (!b.textContent.trim()) setLabel(b, 'In den Warenkorb');
    });
    document.querySelectorAll('button.cd-rewards-free-gift-item-add').forEach(function (b) {
      if (!b.textContent.trim()) setLabel(b, 'Gratis-Geschenk hinzufügen');
    });
  }

  function init() {
    fix();
    // Cart-Apps rendern oft verzögert / bei Interaktion nach -> beobachten (gedrosselt)
    try {
      var t;
      var mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(fix, 300);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
